import { render, staticRenderFns } from "./UnpaidCheckDataTable.vue?vue&type=template&id=210f0353&scoped=true"
import script from "./UnpaidCheckDataTable.vue?vue&type=script&lang=js"
export * from "./UnpaidCheckDataTable.vue?vue&type=script&lang=js"
import style0 from "./UnpaidCheckDataTable.vue?vue&type=style&index=0&id=210f0353&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210f0353",
  null
  
)

export default component.exports